import ACCPBossScreen from './ACCPBossScreen.js';

export default ACCPBossScreen;
